module.exports = __webpack_public_path__ + "img/car-D.df075196.jpg";